import React from 'react';
import Icon from '@mdi/react';
import { mdiAccount } from '../../images/svg';

export default class AvatarIcon extends React.Component {

  render() {
    return (
      <Icon path={mdiAccount} size={2.58} />
    )
  }
}
